import { enqueueSnackbar } from 'notistack';

export const SnackBar = (
  variant: 'error' | 'success' | 'info' | 'warning',
  message: string
  // onView?: () => void
) => {
  enqueueSnackbar(message, {
    variant,
    //   action: (snackbarId) => (
    //     <CloseNotification snackbarId={snackbarId} onClick={onView} />
    //   ),
  });
};
